import React from "react";

// components

import CardStats from "../../components/Cards/CardStats.js";

export default function HeaderStatsPartner({equiposT,criticosT,
   implementaT, implementaP}) {
  return (
    <>
      {/* Header */}
      <div className="relative bg-lightBlue-600 md:pt-10 pb-32 pt-10">
        <div className="px-4 md:px-10 mx-auto w-full">
          <div>
            {/* Card stats */}
            <div className="flex flex-wrap">
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="Clientes"
                  statTitle={equiposT}
                  statArrow=""
                  statNumber= ""
                  statPercent=""
                  statPercentColor=""
                  statDescripiron=""
                  statIconName="fas fa-bullseye"
                  statIconColor="bg-green-500"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="Bolsas Entregadas"
                  statTitle={criticosT}
                  statArrow= ""
                  statNumber= ""
                  statPercent= ""
                  statPercentColor= ""
                  statDescripiron= ""
                  statIconName="fas fa-users"
                  statIconColor="bg-green-300"
                />
              </div>
              <div className="w-full lg:w-6/12 xl:w-3/12 px-4">
                <CardStats
                  statSubtitle="Bolsas Recolectadas"
                  statTitle={implementaT}
                  statArrow= ""
                  statNumber= ""
                  statPercent= ""
                  statPercentColor= ""
                  statDescripiron=""
                  statIconName="fas fa-fan"
                  statIconColor="bg-green-700"
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
